
    import React from 'react';
    import { dynamic } from 'dumi';
    import { Link, AnchorLink, context } from 'dumi/theme';
    import Previewer from 'dumi-theme-mobile/es/builtins/Previewer.js';
import Alert from 'dumi-theme-default/es/builtins/Alert';
import API from 'dumi-theme-default/es/builtins/API';
import Badge from 'dumi-theme-default/es/builtins/Badge';
import Example from 'dumi-theme-default/es/builtins/Example';
import SourceCode from 'dumi-theme-default/es/builtins/SourceCode';
import Tree from 'dumi-theme-default/es/builtins/Tree';
import Table from 'dumi-theme-default/es/builtins/Table';

    // memo for page content, to avoid useless re-render since other context fields changed
    const PageContent = React.memo(({ demos: DUMI_ALL_DEMOS }) => {
      const DumiDemo1 = DUMI_ALL_DEMOS['noticebar-demo'].component

      return (
        <>
          
          <React.Fragment><div className="markdown"><h1 id="noticebar-通知栏"><AnchorLink to="#noticebar-通知栏" aria-hidden="true" tabIndex={-1}><span className="icon icon-link" /></AnchorLink>NoticeBar 通知栏</h1>
<p>用于循环播放展示一组消息通知。</p>
<h3 id="代码演示"><AnchorLink to="#代码演示" aria-hidden="true" tabIndex={-1}><span className="icon icon-link" /></AnchorLink>代码演示</h3>
</div><Previewer {...DUMI_ALL_DEMOS['noticebar-demo'].previewerProps}><DumiDemo1 /></Previewer>
<div className="markdown"><h3 id="api"><AnchorLink to="#api" aria-hidden="true" tabIndex={-1}><span className="icon icon-link" /></AnchorLink>API</h3>





















































<Table><thead><tr><th>参数</th><th>说明</th><th>类型</th><th>默认值</th></tr></thead><tbody><tr><td>duration</td><td>动画时长</td><td>number</td><td>-</td></tr><tr><td>text</td><td>通知文本内容</td><td>string</td><td>-</td></tr><tr><td>center</td><td>是否居中</td><td>boolean</td><td>-</td></tr><tr><td>mode</td><td>通告栏模式，可选值为 不传、closeable、link</td><td>string</td><td>-</td></tr><tr><td>scrollable</td><td>是否开启滚动播放，内容长度溢出时默认开启</td><td>boolean</td><td>-</td></tr><tr><td>onClick</td><td>mode === link 时，整个 NoticeBar 可以点击</td><td>MouseEventHandler</td><td>-</td></tr><tr><td>onClose</td><td>mode === closeable，点击关闭按钮关闭 noticebar</td><td>MouseEventHandler</td><td>-</td></tr></tbody></Table></div></React.Fragment>
        </>
      );
    })

    export default (props) => {
      const { demos } = React.useContext(context);

      // scroll to anchor after page component loaded
      React.useEffect(() => {
        if (props?.location?.hash) {
          AnchorLink.scrollToAnchor(decodeURIComponent(props.location.hash.slice(1)));
        }
      }, []);

      return <PageContent demos={demos} />;
  }